import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { useCopy } from "@/lib/i18n/copy";
import { STICKY_CTA } from "@/content/chrome";

const StickyCTA = ({ offsetBottom = false }: { offsetBottom?: boolean }) => {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isPortal = location.pathname.startsWith("/portal");

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 500);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const { t } = useCopy(STICKY_CTA);

  if (isPortal) return null;

  const handleClick = () => {
    if (location.pathname === "/contact/") {
      document.querySelector("form")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/contact/");
    }
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label={t.label}
      className="fixed right-6 z-50 flex items-center justify-center bg-[#1a1a1a] text-white rounded-full cursor-pointer transition-all duration-300 ease-in-out"
      style={{
        bottom: offsetBottom ? 80 : 24,
        width: hovered ? 200 : 48,
        height: 48,
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <Mail size={20} className="shrink-0" />
      <span
        className="overflow-hidden whitespace-nowrap text-sm font-medium transition-all duration-300"
        style={{
          width: hovered ? 130 : 0,
          opacity: hovered ? 1 : 0,
          marginLeft: hovered ? 10 : 0,
        }}
      >
        {t.label}
      </span>
    </button>
  );
};

export default StickyCTA;
